<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <credit-config>
        </credit-config> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import creditConfig from './todo-credit-config'
export default {
    components: {
        creditConfig
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/base-credit-config.vue